import { useContext, useEffect, useRef } from 'react';
import AuthContext from '../context/AuthContext';
import { acquirePresenceSocket, releasePresenceSocket } from '../utils/presenceSocket';

const HEARTBEAT_MS = 30 * 1000;
const TOKEN_KEY = 'token';

/**
 * Registers the current browser session as online (member if logged in, guest otherwise).
 */
export function usePlatformPresence() {
  const { user } = useContext(AuthContext);
  const socketRef = useRef(null);

  useEffect(() => {
    const socket = acquirePresenceSocket();
    socketRef.current = socket;

    const connect = () => {
      const token = localStorage.getItem(TOKEN_KEY);
      socket.emit('presence:connect', { token: token || undefined });
    };

    socket.on('connect', connect);
    if (socket.connected) connect();

    const heartbeat = setInterval(() => {
      if (!socket.connected) return;
      const token = localStorage.getItem(TOKEN_KEY);
      socket.emit('presence:connect', { token: token || undefined });
      socket.emit('presence:heartbeat');
    }, HEARTBEAT_MS);

    const onStorage = (event) => {
      if (event.key === TOKEN_KEY) connect();
    };
    window.addEventListener('storage', onStorage);

    return () => {
      clearInterval(heartbeat);
      window.removeEventListener('storage', onStorage);
      socket.off('connect', connect);
      socketRef.current = null;
      releasePresenceSocket();
    };
  }, []);

  useEffect(() => {
    const socket = socketRef.current;
    if (!socket?.connected) return;
    const token = localStorage.getItem(TOKEN_KEY);
    socket.emit('presence:connect', { token: token || undefined });
  }, [user?.id]);
}

export default usePlatformPresence;
